import React from 'react'
import Failure from '../../components/Users/CheckoutFailure'
import NavBar from '../../components/Users/NavBar/NavBar'

const CheckoutFailure = () => {
  return (
    <>
    <NavBar/>
    <Failure/>
    </>
  )
}

export default CheckoutFailure